module.exports = __webpack_public_path__ + "img/type_img.7f8b0989.svg";